import React, { useEffect, useState } from 'react';
import { View, ScrollView, StyleSheet, TouchableOpacity, ActivityIndicator } from 'react-native';
import { Text, Button, Card } from 'react-native-paper';
import Icon from 'react-native-vector-icons/FontAwesome';
import { useGetAmSeedPreviewQuery, useSeedAmCatalogueMutation } from '../redux/services/amseedApi';
import { ShowToast } from '../Common/common';

import T from '../Components/T';
/** Adds the standard hotel asset categories + products for the areas this hotel has; existing ones are skipped. */
const AmSeedCatalogue = ({ navigation }: any) => {
  const { data: groups, isFetching } = useGetAmSeedPreviewQuery();
  const [seed, { isLoading: isSeeding }] = useSeedAmCatalogueMutation();
  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    if (groups) setSelected(groups.filter(g => g.suggested).map(g => g.key));
  }, [groups]);

  const toggle = (key: string) =>
    setSelected(prev => (prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]));

  const run = async () => {
    try {
      const res = await seed(selected).unwrap();
      ShowToast(
        res.addedCategories + res.addedProducts === 0
          ? 'Nothing new to add - everything selected already exists'
          : `Added ${res.addedCategories} categories and ${res.addedProducts} products`
      );
      navigation.goBack();
    } catch (e: any) {
      ShowToast(e?.data?.message || 'Could not seed the catalogue', 'error');
    }
  };

  return (
    <ScrollView style={styles.container}>
      <Card style={styles.card}>
        <Text style={styles.intro}>
          <T>Areas found in your hotel are pre-selected. Categories and products you already have (matched by name / code)
          are never changed or duplicated.</T>
        </Text>
        {isFetching || !groups ? (
          <ActivityIndicator color="#2E7D32" style={{ marginVertical: 20 }} />
        ) : (
          groups.map(g => {
            const on = selected.includes(g.key);
            return (
              <TouchableOpacity key={g.key} style={styles.row} onPress={() => toggle(g.key)}>
                <Icon name={on ? 'check-square-o' : 'square-o'} size={22} color={on ? '#2E7D32' : '#888'} />
                <View style={styles.rowBody}>
                  <Text style={styles.label}>{g.label}</Text>
                  <Text style={styles.sub}>
                    {g.newCategories} <T>new categories,</T> {g.newProducts} <T>new products</T>
                    {g.suggested ? '  ·  found in your hotel' : ''}
                  </Text>
                </View>
              </TouchableOpacity>
            );
          })
        )}
      </Card>
      <View style={styles.buttons}>
        <Button mode="contained" onPress={run} loading={isSeeding} disabled={isSeeding || selected.length === 0}>
          Seed selected
        </Button>
        <Button mode="outlined" onPress={() => navigation.goBack()} disabled={isSeeding}>
          Cancel
        </Button>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#f5f5f5', padding: 10 },
  card: { padding: 14, marginBottom: 12 },
  intro: { fontSize: 12, color: '#666', marginBottom: 10 },
  row: { flexDirection: 'row', alignItems: 'center', paddingVertical: 10, borderBottomWidth: 1, borderBottomColor: '#eee' },
  rowBody: { marginLeft: 12, flex: 1 },
  label: { fontSize: 14, fontWeight: 'bold' },
  sub: { fontSize: 11, color: '#666', marginTop: 2 },
  buttons: { gap: 10, marginBottom: 30 }
});

export default AmSeedCatalogue;
